import { useState, useCallback } from "react";

export const useSliderState = (length) => {
  const [state, setState] = useState({
    index: 0,
    nextIndex: 0,
    direction: "left",
    animate: false,
  });

  const goTo = useCallback((index) => {
    setState((state) => {
      const direction = state.index > index ? "left" : "right";
      return {
        index: state.index,
        nextIndex: index,
        direction: direction,
        animate: true,
      };
    });
  }, []);

  const showNext = useCallback(() => {
    setState((state) => {
      if (state.index + 1 >= length) {
        return state;
      }
      return {
        index: state.index,
        nextIndex: state.index + 1,
        direction: "right",
        animate: true,
      };
    });
  }, [length]);

  const showPrev = useCallback(() => {
    setState((state) => {
      if (state.index - 1 < 0) {
        return state;
      }
      return {
        index: state.index,
        nextIndex: state.index - 1,
        direction: "left",
        animate: true,
      };
    });
  }, []);

  const endAnimation = useCallback(() => {
    setState((state) => ({
      ...state,
      animate: false,
      index: state.nextIndex,
    }));
  }, []);

  return { state, showNext, showPrev, endAnimation, goTo };
};
